export var FiltersElements;
(function (FiltersElements) {
  FiltersElements["Corpus"] = "mvk_corpus_filter";
  FiltersElements["Section"] = "mvk_section_filter";
  FiltersElements["Layout"] = "mvk_layout_filter";
  FiltersElements["Level"] = "mvk_level_filter";
})(FiltersElements || (FiltersElements = {}));